import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Grid } from '@mui/material';

interface TableSkeletonProps {
    sx?: any;
}

export default function TableSkeleton({ sx }: TableSkeletonProps) {
    const skeletonCount = 11;

    return (
        <Grid marginTop={1} sx={sx} width={'100vw'}>
            {Array.from({ length: skeletonCount }).map((_, index) => (
                <Skeleton key={index} variant="text" sx={{ fontSize: '3.9rem', margin: '-25px' }} />
            ))}
        </Grid>
    );
}
